// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// 引入element-ui
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// 去掉时间选择器的bug
function RepairProps(cmp) {
  (cmp.mixins || []).forEach(mixin => {
  if (mixin.props && mixin.props.placement) {
  const defaultValue = mixin.props.placement.default
  mixin.data = new Proxy(mixin.data, {
  apply(target, thisArg, argArray) {
  const res = Reflect.apply(target, thisArg, argArray)
  return {
  ...(res || {}),
  placement: defaultValue
  }
  }
  })
  delete mixin.props.placement
  }
  if (mixin.mixins && mixin.mixins.length > 0) {
  RepairProps(mixin)
  }
  })
  }
  
RepairProps(ElementUI.DatePicker)
RepairProps(ElementUI.TimePicker)
RepairProps(ElementUI.TimeSelect)

Vue.use(ElementUI);
// 引入v-touch
import VueTouch from 'vue-touch'
Vue.use(VueTouch, {name: 'v-touch'})
// 引入图片预览
import VueDirectiveImagePreviewer from 'vue-directive-image-previewer'
import 'vue-directive-image-previewer/dist/assets/style.css'
Vue.use(VueDirectiveImagePreviewer)

// 路由跳转后返回页面顶端
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})

// 引入全局常量
import constant from './common/constant/constant'
Vue.prototype.$CONS = constant
// 引入全局函数
import cusfunc from './common/cusfunc/cusfunc'
Vue.prototype.$CUSFUNC = cusfunc
// 引入列表展示组件
import MyList from './components/MyList'
Vue.component(MyList.name, MyList)
// 引入loading组件
import Loading from './components/Loading'
Vue.component(Loading.name, Loading)

// 引入md5工具
import md5 from 'js-md5'
Vue.prototype.$md5 = md5

// 引入设置带有效时间的localStorage
import storage from './common/storage'
Vue.prototype.$STO = storage

// 引入axios调接口
import axios from 'axios'
Vue.prototype.$http = axios.create({
  // 设置超时时间
  timeout: 600 * 1000
})
Vue.prototype.$authHttp = axios.create({
  headers: {
    'accessToken': storage.get(constant.TOKEN_KEY)
  },
  timeout: 10 * 1000
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js